/* eslint-disable react/display-name */
import React from 'react'
import style from './index.scss'
import withAngleMaskClasses, {
  AngleMaskClassesProps,
  AngleMaskWrapperProps,
} from './with-angle-mask-classes'

const withAngleClasses = <P extends AngleMaskClassesProps>(
  Component: React.ComponentType<P>
): React.FC<AngleMaskWrapperProps<P>> => (props: AngleMaskWrapperProps<P>) => (
  <Component angleClasses={style} {...props as P} />
)

export { withAngleClasses, withAngleMaskClasses }
